<template>
  <div>
    <div
      v-if="reloading || loadingTiles || loadingReportDiagnosis || loadingDiagnosis"
      class="loading d-flex flex-column align-center my-5"
    >
      <h3 class="text-h4 mb-3">
        {{ searchStatus }}
      </h3>
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <Visualizer
      v-if="!reloading && !loadingTiles && !loadingReportDiagnosis && !loadingDiagnosis"
      :slide="slide"
    ></Visualizer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Visualizer from "@/components/service/Visualizer";
import {
  LOAD_DIAGNOSIS,
} from "@/store/modules/diagnosis";
import {
  LOAD_REPORTBATCHES,
  SET_CURRENT_INDEX_REPORTWSI,
  ACTION_SET_CURRENT_REPORTDIAGNOSIS,
  ACTION_SET_CURRENT_REPORTWSI,
  ACTION_SET_CURRENT_REPORTTILEGRID,
} from "@/store/modules/service";

export default {
  components: { Visualizer },
  data() {
    return {
      floatMode: true,
      reloading: true
    };
  },
  computed: {
    ...mapState({
      loadingTiles: state => state.service.loadingReportTileGrid,
      loadingReportDiagnosis: state => state.service.loadingReportDiagnosis,
      loadingDiagnosis: state => state.diagnosis.loading,
      reportTileGrid: state => state.service.currentReportTileGrid,
      reportWSI: state => state.service.currentReportWSI
    }),
    searchStatus() {
      return this.$t("diagnosis.visualization.loading.retrieving")
    },
    slide() {
      if (this.reportTileGrid) {
        return {
          width: this.reportTileGrid.tilegrid_json.general.width,
          height: this.reportTileGrid.tilegrid_json.general.length,
          path: this.reportWSI.filename + ".ndpi"
        };
      }
      return {
        width: 0,
        height: 0,
        path: null
      }
    }
  },
  async created() {
    if (!this.reportTileGrid) {
      this.reloading = true
      await this.$store.dispatch(LOAD_REPORTBATCHES, undefined);
      const id = this.$route.params.id
      const index = this.$store.state.service.allIdsReportWSI.indexOf(id.toString())
      this.$store.commit(SET_CURRENT_INDEX_REPORTWSI, index);
      await this.$store.dispatch(LOAD_DIAGNOSIS);
      await this.$store.dispatch(ACTION_SET_CURRENT_REPORTWSI, { id });
      await this.$store.dispatch(ACTION_SET_CURRENT_REPORTTILEGRID, { id });
      await this.$store.dispatch(ACTION_SET_CURRENT_REPORTDIAGNOSIS, { id });
    }
    this.reloading = false
  },
};
</script>
